/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { UsePaginationInstanceProps, UsePaginationState } from 'react-table';
import Table from '../Table';
import { TableProps } from '../Table/Table';
import PaginationV2 from './PaginationV2';

export interface PaginationTableProps<D extends Record<string, unknown>> extends TableProps<D> {
  /**
   * @deprecated Use initialState.pageSize instead
   *
   * ex: initialState: {
   *  pageSize: 20
   * }
   */
  initialPageSize?: number;
  pageSizeOptions?: Array<number>;
  enableGoToPage?: boolean;
}

const PaginationTable = <D extends Record<string, unknown>>({
  pageSizeOptions,
  initialPageSize,
  enableGoToPage = false,
  ...rest
}: PaginationTableProps<D>): JSX.Element => {
  return (
    <>
      <Table
        {...rest}
        {...(initialPageSize !== undefined
          ? {
              initialState: {
                pageSize: initialPageSize,
                ...rest?.initialState,
              },
            }
          : {})}
        pagination={{
          render: (
            _dataSize,
            {
              pageCount,
              gotoPage,
              setPageSize,
              pageIndex,
              pageSize,
            }: UsePaginationInstanceProps<D> & UsePaginationState<D>,
          ) => (
            <PaginationV2
              pageCount={pageCount}
              gotoPage={gotoPage}
              setPageSize={setPageSize}
              pageIndex={pageIndex}
              pageSize={pageSize}
              pageSizeOptions={pageSizeOptions}
              enableGoToPage={enableGoToPage}
            />
          ),
        }}
      />
    </>
  );
};

export default PaginationTable;
